import React, { useContext } from 'react';
import { GridApi, GridOptions } from 'ag-grid-community';
import { useTheme } from '@material-ui/core/styles';
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import { PNGlobalContext } from '@mummssoftware/global-context/PNGlobalContext';
import { AgGridTableWrapper } from '@mummssoftware/common-ui';
import { OrdersContext } from '../../context';
import {
  OrderTextCell,
  PhysicianCell,
  OrderDateCell,
  OrderCreationCell,
  NoteCountCellRenderer,
} from './CellRenderer';
import {
  smallWidgetCPColumnDefs,
  expandedWidgetCPColumnDefs,
  expandedWidgetPatientColumnDefs,
  smallWidgetPatientColumnDefs,
} from './TableColumnDef';

import 'ag-grid-community/dist/styles/ag-grid.css';
import '@mummssoftware/common-ui/style/css/ag-theme-hummingbird.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

LicenseManager &&
  LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_KEY as string);

interface OrdersTableProps {
  viewModePrint?: boolean;
  smallWidget?: boolean;
}
const frameworkComponents = {
  orderTextCell: OrderTextCell,
  physicianCell: PhysicianCell,
  orderDateCell: OrderDateCell,
  orderCreationCell: OrderCreationCell,
  noteCountCellRenderer: NoteCountCellRenderer,
};

export const OrdersTable = ({
  viewModePrint,
  smallWidget,
}: OrdersTableProps) => {
  const {
    props: {
      grid: { rowHeight, headerHeight, className },
    },
  } = useTheme() as any;

  const { patient } = useContext(OrdersContext);
  const { patientOrdersGlobal } = useContext(PNGlobalContext);

  let columnDefs;
  if (patient) {
    columnDefs = smallWidget
      ? smallWidgetPatientColumnDefs
      : expandedWidgetPatientColumnDefs;
  } else {
    columnDefs = smallWidget
      ? smallWidgetCPColumnDefs
      : expandedWidgetCPColumnDefs;
  }

  const gridOptions: GridOptions = {
    defaultColDef: {
      resizable: true,
      filter: true,
    },
    columnDefs,
    onGridReady: (params: any) => {
      const gridApi: GridApi = params.api;
      gridApi.sizeColumnsToFit();
      // @strategy for PRINT to work!
      if (gridApi) {
        if (viewModePrint) {
          gridApi.setDomLayout('print');
        }
      }
    },
  };

  return (
    <AgGridTableWrapper
      id="orders-table-wrapper"
      className={`${className} light max-width`}
      printMode={viewModePrint}
    >
      <AgGridReact
        gridOptions={gridOptions}
        rowData={patientOrdersGlobal || []}
        rowHeight={rowHeight}
        headerHeight={headerHeight}
        frameworkComponents={frameworkComponents}
      />
    </AgGridTableWrapper>
  );
};

export default OrdersTable;
